
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ReportDashboard.html?raw';
import "../../../moreCore/UI/Button/Button";
import FileDashboardManager from '../FileDashboardManager';
import "../FileDashboardManager";
import _TabEnabledMixin from '../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import NavigationArea from '../../../moreCore/UI/Navigation/NavigationArea';
//import FileTile = require("../FileTile");
//import "../FileTile";

import { FileDashboard } from "../FileDashboardTypes";

class ReportDashboard extends compose(_TabEnabledMixin) {
    templateString: any = template;

    private manager: MdsLax<InstanceType<typeof FileDashboardManager>>;
    private errorMessageNode: HTMLElement;
    private tileRegistry: Array<{ tilename: string, manager: MdsLax<InstanceType<typeof FileDashboardManager>> }> = [];
    private navigationContainer: HTMLElement;

    loadReportDashboard(targetTile?: string, heading?: string): void {

        if( heading) this.manager.setHeading(this.translate("ReportDashboard_Title"));

        let data = {

        };

        let url = window.appRoot + "FileDashboard/GetReportDashTiles"
        let responseHitch: any = lang.hitch(this, this._onLoadDashboardResponse);

        if (this.isEmbeddedInTab) {

            if (targetTile) {
                data["targetTile"] = targetTile;
                let reg = this.getTileRegistryEntryByName(targetTile);
                if (reg) {
                    responseHitch = lang.hitch(this, this._onLoadSingleTile, reg.manager, heading);
                    reg.manager.StandbyStart();
                }
            } else {
                url = window.appRoot + "FileDashboard/GetReportNavigationArea"
                //data["tabbed"] = true;
                responseHitch = lang.hitch(this, this._onLoadDashboardNavigation);

                this.StandbyStart();

            }
        } else {
            this.hideNode(this.manager.domNode, false);
            this.StandbyStart(this.domNode);

        }

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            responseHitch,
            lang.hitch(this, this._onLoadDashboardError),
            false // sync
        );
    }
    private _onLoadDashboardNavigation(response: Array<Navigation.NavigationSet>) {

        this.hideNode(this.manager.domNode);
        this.hideNode(this.navigationContainer, false);

        this.StandbyStop();

        // die empfangenen Tiles als Navigation zusammenstellen
        for (let config of response) {
            this.addNavigationArea(config);
        }
    }

    private _onLoadSingleTile(targetManager: MdsLax<InstanceType<typeof FileDashboardManager>>, heading: string, data: FileDashboard.DashboardData) {
        targetManager.setData(data);
        if (heading) {
            //targetManager.setHeading(heading);
        }
    }
    private _onLoadDashboardResponse(response: FileDashboard.DashboardData) {
        //console.log("_onLoadDashboardResponse", response);


        this.tileRegistry = [];
        this.UiModder.domConstruct.empty(this.navigationContainer);
        this.hideNode(this.navigationContainer);

        if (this.isEmbeddedInTab) {
            

        } else {
            this.manager.setData(response);
        }

        this.StandbyStop();

        this.hideNode(this.errorMessageNode);
    }

    /**
     * Hinweis: Das Callback der Navigation-Config wird überschrieben.
     * @param sectionName
     * @param config
     */
    addNavigationArea(config: Navigation.NavigationSet) {
        let navigation = new NavigationArea();

        navigation.placeAt(this.navigationContainer);

        for (let tile of config.tiles) {
            
            this.tileRegistry.push({
                manager: null,
                tilename: tile.name
            });

            tile.target = null;
            tile.width = "20ch";
            tile.widthMode = "strict";
            tile.callback = lang.hitch(this, this._onNavigateToTab, tile.name, tile.label);
        }

        navigation.setConfig(config, null, "left");

    }

    private _onLoadDashboardError(error: more.requestErrorMessage) {
        console.error("_onLoadDashboardError", error.Message);

        this.StandbyStop();

        alert("error loading report dashboard - maybe try again?\r\n" + error.Message);
        this.errorMessageNode.innerHTML = error.Message;
    }

    private getTileRegistryEntryByName(name: string) {
        for (let reg of this.tileRegistry) {
            if (reg.tilename == name) {
                return reg;
            }
        }

        return null;
    }

    private _onNavigateToTab(name: string, heading: string, tileconfig: Navigation.TileData) {
        if (!this.isEmbeddedInTab) return;
        
        let reg = this.getTileRegistryEntryByName(name);

        if (reg.manager == null || reg.manager._destroyed) {
            let manager = new FileDashboardManager();
            
            this.requestNewTabbedContent({
                name: name,
                enableClosing: true,
                label: tileconfig.label,
                coloration: tileconfig.colorBG,
                sidebarEntryName: name,
                widget: manager,
                //heading: tileconfig.label,
                iconclass: tileconfig.iconclass
            }, true);

            manager.on("requestFile", lang.hitch(this, this._onFileRequestedByManager));
            manager.startup();
            manager.setHeading(heading);
            reg.manager = manager;

            this.loadReportDashboard(name, null); //, tileconfig.label);
        } else {
            this.requestTabswitch(reg.tilename);
        }
    }

    private _onFileRequestedByManager(requestdata: FileDashboard.FileRequestData) {
        //console.debug("_onFileRequestedByManager", requestdata);

        //let data = requestdata.filterpanelData;

        let url = window.appRoot + "FileDashboard/RequestReport"
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(requestdata)
            },
            lang.hitch(this, this._onRequestReportResponse, requestdata),
            lang.hitch(this, this._onRequestReportError, requestdata),
            false // sync
        );
    }

    private _onRequestReportResponse(requestdata: FileDashboard.FileRequestData, response: FileFinder.FileDescriptor) {
        let data: FileDashboard.FileResponseData = { fileData: response, fileTileName: requestdata.fileTileName, targetRowIndex: requestdata.rowIndex, error: null };
        if (this.isEmbeddedInTab) {
            let reg = this.getTileRegistryEntryByName(requestdata.fileTileName);
            if (reg && reg.manager) {
                reg.manager.fileRequestResponse(data);
            }
        } else {
            this.manager.fileRequestResponse(data);
        }
    }

    private _onRequestReportError(requestdata: FileDashboard.FileRequestData, error: more.requestErrorMessage) {
        let data: FileDashboard.FileResponseData = { fileData: null, fileTileName: requestdata.fileTileName, targetRowIndex: requestdata.rowIndex, error: error.Message };

        if (this.isEmbeddedInTab) {
            let reg = this.getTileRegistryEntryByName(requestdata.fileTileName);
            if (reg && reg.manager) {
                reg.manager.fileRequestResponse(data);
            }
            else {
                alert(data.error);
            }
        } else {
            this.manager.fileRequestResponse(data);
        }
    }

    _onEmbedding(config: Tabbing.TabContainerPage, name: string): void {
        super._onEmbedding.apply(this, arguments as any);

        // 1:1 durchreichen an den Manager
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.manager.on("requestFile", lang.hitch(this, this._onFileRequestedByManager));

        this.loadReportDashboard();

        this.setTitles(this.stringFormat(this.translate("ReportDashboard__MainTitle"), this.translate("MainTitle")),
            this.translate("ReportDashboard_Title"));
    }
}

export default mdsWidget(ReportDashboard);
